import { promiseActionFactory } from "@teroneko/redux-saga-promise";

import { createActionTypes } from "utils/store";
import { LoadListDataParams, LoadListDataResponse } from "hooks/useListData";
import { IDistribution, IDistributionData } from "types/distribution.types";

export const DISTRIBUTION_REDUCER = 'distribution';

const DISTRIBUTION_ACTIONS = {
  LOAD_DISTRIBUTIONS: 'LOAD_DISTRIBUTIONS',
  CREATE_DISTRIBUTION: 'CREATE_DISTRIBUTION',
  EDIT_DISTRIBUTION: 'EDIT_DISTRIBUTION',
};

const actionTypes = createActionTypes(DISTRIBUTION_REDUCER, DISTRIBUTION_ACTIONS);

export const loadDistributionsAction = promiseActionFactory<LoadListDataResponse<IDistribution>>().create<LoadListDataParams>(actionTypes.LOAD_DISTRIBUTIONS);
export const createDistributionAction = promiseActionFactory().create<IDistributionData>(actionTypes.CREATE_DISTRIBUTION);
export const editDistributionAction = promiseActionFactory().create<IDistribution>(actionTypes.EDIT_DISTRIBUTION);
